import { gql } from "@apollo/client";

export default gql`
  query VendorActions($vendorSlug: String!) {
    company(slug: $vendorSlug) {
      _id
      actionsCount
      actions {
        _id
        group {
          _id
          slug
          name
          logo
        }
        inviter {
          ... on PendingUser {
            _id
            slug
            fullName
            avatar
          }
          ... on VendorUser {
            _id
            slug
            fullName
            avatar
          }
          ... on GovernmentUser {
            _id
            slug
            fullName
            avatar
          }
        }
        createdAt
      }
    }
  }
`;
